'use strict';
import React from 'react';
import flux from 'utils/flux';
import dom from 'utils/dom';

import t from 'tcomb-form';
var Form = t.form.Form;

var ChangePassword = t.struct({
    current_password: t.Str,
    password: t.Str, // t.subtype(t.Str, (s) => s.length > 9),
    password_repeat: t.Str
});


var AccountPasswordPage = React.createClass({
    displayName: 'AccountPasswordPage',
    propTypes: {},
    getInitialState() {
        return {
            changePasswordSuccess: false
        };
    },
    onChange(value) {
        this.setState(value);
    },
    renderError() {
        if (this.props.appStore.error) {
            return <div className="field__error">{this.props.appStore.error}</div>;
        }
    },
    onSubmit(e) {
        e.preventDefault();
        var passwordData = this.refs.form.getValue();
        if (passwordData) {
            flux.getStore('app').updatePassword({
                password: passwordData.password,
                current_password: passwordData.current_password
            }).then(() => {
                this.setState({changePasswordSuccess: true});
            });
        }
    },
    render() {
        if (this.state.changePasswordSuccess) {
            return (<h4 className="form__success">{flux.t('account_password_new_success')}</h4>);
        }
        var options = {
            auto: 'labels',
            fields: {
                current_password: {
                    type: 'password',
                    error: flux.t('validation_password'),
                    label: flux.t('account_password_current')
                },
                password: {
                    type: 'password',
                    error: flux.t('validation_password'),
                    label: flux.t('account_password_new')
                },
                password_repeat: {
                    type: 'password',
                    hasError: this.state.password !== this.state.password_repeat,
                    error: flux.t('validation_password_repeat'),
                    label: flux.t('account_password_confirm')
                }
            }
        };

        return (
            <div className="account__editpassword">
                <h4>{flux.t('account_password_change_head')}</h4>
                <p dangerouslySetInnerHTML={dom.setInnerHtml(flux.t('account_password_required'))} />
                <form onSubmit={this.onSubmit}>
                    <div className="editpassword__form">
                        <Form
                          ref="form"
                          type={ChangePassword}
                          options={options}
                          value={this.state}
                          onChange={this.onChange}
                        />
                        {this.renderError()}
                    </div>

                    <hr className="white" />
                    <div className="editpassword__buttons">
                        <button disabled={flux.getStore('app').isLoading()} type="submit" className="btn btn-primary btn-arrow">
                            {flux.t('account_password_change_head')}
                            <i className="chevron-right" />
                        </button>
                    </div>
                </form>
            </div>
        );
    }
});

module.exports = AccountPasswordPage;



// WEBPACK FOOTER //
// ./app/pages/account/accountPassword.jsx